import React from 'react';
import ResourceSubTile from "../dashboard/ResourceSubTile";

const Covid19Tile = ({
    disabled
}) => {
    return (
        <ResourceSubTile
            className="covid-19-tile"
            heading="COVID-19"
            logName="COVID19"
            description={<>Schedule a vaccine or view your credentials.</>}
            disabled={disabled}
            url={"/covid19care"}
        />
    );
}

export default Covid19Tile;
